import { createRouter, createWebHashHistory } from 'vue-router';
import StartStep from '@/components/steps/StartStep.vue';
import HausStep1 from '@/components/steps/haus/HausStep1.vue';
import HausStep2 from '@/components/steps/haus/HausStep2.vue';
import HausStep3 from '@/components/steps/haus/HausStep3.vue';
import HausStep4 from '@/components/steps/haus/HausStep4.vue';
import HausStep5 from '@/components/steps/haus/HausStep5.vue';
import HausStep6 from '@/components/steps/haus/HausStep6.vue';
import HausStep7a from '@/components/steps/haus/HausStep7a.vue';
import HausStep7b from '@/components/steps/haus/HausStep7b.vue';
import HausStep8 from '@/components/steps/haus/HausStep8.vue';
import HausStep9 from '@/components/steps/haus/HausStep9.vue';
import HausStep10a from '@/components/steps/haus/HausStep10a.vue';
import HausStep10b from '@/components/steps/haus/HausStep10b.vue';
import HausStep10c from '@/components/steps/haus/HausStep10c.vue';
import WohnungStep1 from '@/components/steps/wohnung/WohnungStep1.vue';
import WohnungStep2 from '@/components/steps/wohnung/WohnungStep2.vue';
import WohnungStep3 from '@/components/steps/wohnung/WohnungStep3.vue';
import WohnungStep4 from '@/components/steps/wohnung/WohnungStep4.vue';
import WohnungStep5 from '@/components/steps/wohnung/WohnungStep5.vue';
import WohnungStep6 from '@/components/steps/wohnung/WohnungStep6.vue';
import WohnungStep7a from '@/components/steps/wohnung/WohnungStep7a.vue';
import WohnungStep7b from '@/components/steps/wohnung/WohnungStep7b.vue';
import WohnungStep8 from '@/components/steps/wohnung/WohnungStep8.vue';
import WohnungStep9 from '@/components/steps/wohnung/WohnungStep9.vue';
import WohnungStep10a from '@/components/steps/wohnung/WohnungStep10a.vue';
import WohnungStep10b from '@/components/steps/wohnung/WohnungStep10b.vue';
import WohnungStep10c from '@/components/steps/wohnung/WohnungStep10c.vue';
import DgWohnungStep1 from '@/components/steps/dg-wohnung/DgWohnungStep1.vue';
import DgWohnungStep2 from '@/components/steps/dg-wohnung/DgWohnungStep2.vue';
import DgWohnungStep3 from '@/components/steps/dg-wohnung/DgWohnungStep3.vue';
import DgWohnungStep4 from '@/components/steps/dg-wohnung/DgWohnungStep4.vue';
import DgWohnungStep5 from '@/components/steps/dg-wohnung/DgWohnungStep5.vue';
import DgWohnungStep6 from '@/components/steps/dg-wohnung/DgWohnungStep6.vue';
import DgWohnungStep7a from '@/components/steps/dg-wohnung/DgWohnungStep7a.vue';
import DgWohnungStep7b from '@/components/steps/dg-wohnung/DgWohnungStep7b.vue';
import DgWohnungStep8 from '@/components/steps/dg-wohnung/DgWohnungStep8.vue';
import DgWohnungStep9 from '@/components/steps/dg-wohnung/DgWohnungStep9.vue';
import DgWohnungStep10a from '@/components/steps/dg-wohnung/DgWohnungStep10a.vue';
import DgWohnungStep10b from '@/components/steps/dg-wohnung/DgWohnungStep10b.vue';
import DgWohnungStep10c from '@/components/steps/dg-wohnung/DgWohnungStep10c.vue';

const routes = [
  { path: '/', alias: '/start', name: 'Start', component: StartStep },
  { path: '/haus-step-1', name: 'HausStep1', component: HausStep1 },
  { path: '/haus-step-2', name: 'HausStep2', component: HausStep2 },
  { path: '/haus-step-3', name: 'HausStep3', component: HausStep3 },
  { path: '/haus-step-4', name: 'HausStep4', component: HausStep4 },
  { path: '/haus-step-5', name: 'HausStep5', component: HausStep5 },
  { path: '/haus-step-6', name: 'HausStep6', component: HausStep6 },
  { path: '/haus-step-7a', name: 'HausStep7a', component: HausStep7a },
  { path: '/haus-step-7b', name: 'HausStep7b', component: HausStep7b },
  { path: '/haus-step-8', name: 'HausStep8', component: HausStep8 },
  { path: '/haus-step-9', name: 'HausStep9', component: HausStep9 },
  { path: '/haus-step-10a', name: 'HausStep10a', component: HausStep10a },
  { path: '/haus-step-10b', name: 'HausStep10b', component: HausStep10b },
  { path: '/haus-step-10c', name: 'HausStep10c', component: HausStep10c },
  { path: '/wohnung-step-1', name: 'WohnungStep1', component: WohnungStep1 },
  { path: '/wohnung-step-2', name: 'WohnungStep2', component: WohnungStep2 },
  { path: '/wohnung-step-3', name: 'WohnungStep3', component: WohnungStep3 },
  { path: '/wohnung-step-4', name: 'WohnungStep4', component: WohnungStep4 },
  { path: '/wohnung-step-5', name: 'WohnungStep5', component: WohnungStep5 },
  { path: '/wohnung-step-6', name: 'WohnungStep6', component: WohnungStep6 },
  { path: '/wohnung-step-7a', name: 'WohnungStep7a', component: WohnungStep7a },
  { path: '/wohnung-step-7b', name: 'WohnungStep7b', component: WohnungStep7b },
  { path: '/wohnung-step-8', name: 'WohnungStep8', component: WohnungStep8 },
  { path: '/wohnung-step-9', name: 'WohnungStep9', component: WohnungStep9 },
  {
    path: '/wohnung-step-10a',
    name: 'WohnungStep10a',
    component: WohnungStep10a,
  },
  {
    path: '/wohnung-step-10b',
    name: 'WohnungStep10b',
    component: WohnungStep10b,
  },
  {
    path: '/wohnung-step-10c',
    name: 'WohnungStep10c',
    component: WohnungStep10c,
  },
  {
    path: '/dg-wohnung-step-1',
    name: 'DgWohnungStep1',
    component: DgWohnungStep1,
  },
  {
    path: '/dg-wohnung-step-2',
    name: 'DgWohnungStep2',
    component: DgWohnungStep2,
  },
  {
    path: '/dg-wohnung-step-3',
    name: 'DgWohnungStep3',
    component: DgWohnungStep3,
  },
  {
    path: '/dg-wohnung-step-4',
    name: 'DgWohnungStep4',
    component: DgWohnungStep4,
  },
  {
    path: '/dg-wohnung-step-5',
    name: 'DgWohnungStep5',
    component: DgWohnungStep5,
  },
  {
    path: '/dg-wohnung-step-6',
    name: 'DgWohnungStep6',
    component: DgWohnungStep6,
  },
  {
    path: '/dg-wohnung-step-7a',
    name: 'DgWohnungStep7a',
    component: DgWohnungStep7a,
  },
  {
    path: '/dg-wohnung-step-7b',
    name: 'DgWohnungStep7b',
    component: DgWohnungStep7b,
  },
  {
    path: '/dg-wohnung-step-8',
    name: 'DgWohnungStep8',
    component: DgWohnungStep8,
  },
  {
    path: '/dg-wohnung-step-9',
    name: 'DgWohnungStep9',
    component: DgWohnungStep9,
  },
  {
    path: '/dg-wohnung-step-10a',
    name: 'DgWohnungStep10a',
    component: DgWohnungStep10a,
  },
  {
    path: '/dg-wohnung-step-10b',
    name: 'DgWohnungStep10b',
    component: DgWohnungStep10b,
  },
  {
    path: '/dg-wohnung-step-10c',
    name: 'DgWohnungStep10c',
    component: DgWohnungStep10c,
  },
];

let historyPath = '/price-indicator';

if (process.env.VUE_APP_DEPLOYMENT === 'production') {
  historyPath = 'erstebank/deaktiv/k25/price-indicator';
}

const router = createRouter({
  history: createWebHashHistory(historyPath),
  routes,
  scrollBehavior() {
    {
      return {
        el: '.scrollPosition',
        top: 95,
        behavior: 'smooth',
      };
    }
  },
});

export default router;
